/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Severityother1Inputs */

const en_severityother1 = /** @type {(inputs: Severityother1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Other`)
};

const pt_severityother1 = /** @type {(inputs: Severityother1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Outro`)
};

/**
* | output |
* | --- |
* | "Other" |
*
* @param {Severityother1Inputs} inputs
* @param {{ locale?: "en" | "pt" }} options
* @returns {LocalizedString}
*/
const severityother1 = /** @type {((inputs?: Severityother1Inputs, options?: { locale?: "en" | "pt" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Severityother1Inputs, { locale?: "en" | "pt" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_severityother1(inputs)
	return pt_severityother1(inputs)
});
export { severityother1 as "severityOther" }